import { getAPI } from "./axios-base";
import { Product } from "@/models/Product";

export default class RestResourceLog {
  postLog(log: any) {
    console.log(log);
    console.log("Log");
    console.log(log);
    const formdata = new FormData();
    if (log.quantity) formdata.append("quantity", log.quantity);
    formdata.append("logId", log._id);
    if (log.files) {
      console.log(log.files);
      log.files.forEach((p: string | Blob, i: any) => {
        formdata.append(`files[${i}]`, p);
      });
    }
    return getAPI.post("api/rest/v1/log/update-log", formdata, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  getImage(url: string, id: string) {
    return getAPI.get(`api/rest/v1/minio/media/${url}?productId=${id}`);
  }

  deleteImages(id: string) {
    return getAPI.delete(`api/rest/v1/log/delete-pictures/${id}`);
  }
}
